import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';
import { useAsyncSafeState } from 'ui-components/hooks/async-safe';

import { errorMessageFromCodeMap, unknownError } from './constants';
import messages from './messages';
import style from './style.module.less';
import { ConfirmDialogueModal } from '../../components/modals/confirm-dialogue-modal';

const getErrorMessage = (errorCode) => {
  const errorMessage = errorMessageFromCodeMap[errorCode] ?? errorMessageFromCodeMap[unknownError];
  return errorMessage;
};
const DeleteFulfillmentPlanModalBody = ({ errorCode = '' }) => (
  <>
    <FormattedMessage {...messages.deleteModalBody} />
    {!!errorCode && (
      <BannerMessageV2
        className={style['delete-modal-error-banner']}
        content={<FormattedMessage {...getErrorMessage(errorCode)} />}
        status={BannerStatus.Error}
      />
    )}
  </>
);

DeleteFulfillmentPlanModalBody.propTypes = {
  errorCode: PropTypes.string,
};

const DeleteFulfillmentPlanConfirmationModal = ({ errorCode = '', onClose, onDelete }) => {
  const [isProcessing, setIsProcessing] = useAsyncSafeState(false);
  const [clickCount, setClickCount] = useAsyncSafeState(0);

  const handleDelete = useCallback(async () => {
    setClickCount((count) => count + 1);
    setIsProcessing(true);
    try {
      await onDelete();
    } catch {
      setIsProcessing(false);
    }
  }, [onDelete, setClickCount, setIsProcessing]);

  return (
    <ConfirmDialogueModal
      body={<DeleteFulfillmentPlanModalBody errorCode={errorCode} />}
      buttonDisabled={isProcessing || clickCount > 3}
      buttonMessage={<FormattedMessage {...messages.deleteShipment} />}
      buttonTheme='danger'
      header={<FormattedMessage {...messages.deleteModalHeader} />}
      onClose={onClose}
      onConfirm={handleDelete}
    />
  );
};

DeleteFulfillmentPlanConfirmationModal.propTypes = {
  errorCode: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export { DeleteFulfillmentPlanConfirmationModal };
